import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-5" }
const _hoisted_4 = { class: "row mt-5" }
const _hoisted_5 = { class: "col-lg-4 mb-3" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<option value=\"1\">January</option><option value=\"2\">February</option><option value=\"3\">March</option><option value=\"4\">April</option><option value=\"5\">May</option><option value=\"6\">June</option><option value=\"7\">July</option><option value=\"8\">August</option><option value=\"9\">September</option><option value=\"10\">October</option><option value=\"11\">November</option><option value=\"12\">December</option>", 12)
const _hoisted_19 = { class: "col-lg-2 text-center mb-1" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "indicator-label" }, " View ", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "col-lg-3" }, null, -1)
const _hoisted_23 = { class: "col-lg-4" }
const _hoisted_24 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3 mt-5" }
const _hoisted_25 = { class: "d-flex align-items-center" }
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-success me-2" }, null, -1)
const _hoisted_27 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_28 = {
  class: "mb-0 dashboardFontStyle",
  id: "totalcom"
}
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "  YOUR TOTAL AEFC EARNINGS FOR THIS MONTH", -1)
const _hoisted_30 = { class: "row col-lg-12" }
const _hoisted_31 = { class: "col-lg-8" }
const _hoisted_32 = { class: "card" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createVNode("h3", { class: "card-label" }, "AEFC COMMISSION OVERVIEW")
  ])
], -1)
const _hoisted_34 = { class: "card-body" }
const _hoisted_35 = { class: "table-responsive" }
const _hoisted_36 = { class: "table table-head-custom table-vertical-center table-head-bg table-borderless" }
const _hoisted_37 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-50px rounded-start" }, "Ref. #"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "User"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-50px" }, "Description"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-50px" }, "Commission")
  ])
], -1)
const _hoisted_38 = { class: "d-flex align-items-center" }
const _hoisted_39 = {
  class: "col-md-12",
  align: "center"
}
const _hoisted_40 = /*#__PURE__*/_createVNode("a", { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }, " ", -1)
const _hoisted_41 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_42 = { class: "pl-0 pt-8" }
const _hoisted_43 = { class: "d-flex align-items-center" }
const _hoisted_44 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_45 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_46 = { class: "d-flex align-items-center" }
const _hoisted_47 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_48 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_49 = { class: "d-flex align-items-center" }
const _hoisted_50 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_51 = /*#__PURE__*/_createTextVNode("Level:    ")
const _hoisted_52 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_53 = { class: "text-muted font-weight-bold d-block" }
const _hoisted_54 = /*#__PURE__*/_createTextVNode("Value:   ")
const _hoisted_55 = { class: "text-dark-75 font-weight-bolder text-hover-primary mb-1 font-size-lg" }
const _hoisted_56 = { class: "col-lg-4" }
const _hoisted_57 = { class: "card" }
const _hoisted_58 = /*#__PURE__*/_createVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createVNode("h3", { class: "card-label" }, "AEFC EARNINGS SUMMARY FOR THIS MONTH")
  ])
], -1)
const _hoisted_59 = { class: "card-body" }
const _hoisted_60 = { class: "table-responsive" }
const _hoisted_61 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_62 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-200px rounded-start" }, "Level"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Total")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_pagination = _resolveComponent("pagination")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("div", _hoisted_5, [
                _withDirectives(_createVNode("input", {
                  type: "text",
                  class: "form-control form-control-lg form-control-solid mb-2",
                  placeholder: "year",
                  name: "year",
                  readonly: "",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.year = $event))
                }, null, 512), [
                  [_vModelText, _ctx.year]
                ])
              ]),
              _createVNode("div", _hoisted_6, [
                _withDirectives(_createVNode("select", {
                  class: "form-select form-select-solid form-select-lg fw-bold mb-2",
                  name: "month",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.month = $event))
                }, [
                  _hoisted_7
                ], 512), [
                  [_vModelSelect, _ctx.month]
                ])
              ]),
              _createVNode("div", _hoisted_19, [
                _createVNode("button", {
                  type: "submit",
                  class: "btn btn-primary er fs-4 px-8 py-2 mt-1 mb-1",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadAEFCSummary()))
                }, [
                  _hoisted_20,
                  _hoisted_21
                ])
              ])
            ])
          ]),
          _hoisted_22,
          _createVNode("div", _hoisted_23, [
            _createVNode("div", _hoisted_24, [
              _createVNode("div", _hoisted_25, [
                _hoisted_26,
                _createVNode("div", _hoisted_27, [
                  _createVNode("p", _hoisted_28, _toDisplayString(_ctx.numberWithCommas(_ctx.totalcom.toFixed(2))), 1)
                ])
              ]),
              _hoisted_29
            ])
          ])
        ]),
        _createVNode("div", _hoisted_30, [
          _createVNode("div", _hoisted_31, [
            _createVNode("div", _hoisted_32, [
              _hoisted_33,
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("table", _hoisted_36, [
                    _hoisted_37,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                        return (_openBlock(), _createBlock("tr", { key: index }, [
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_38, [
                              _createVNode("div", _hoisted_39, [
                                _hoisted_40,
                                _createVNode("span", _hoisted_41, _toDisplayString(index + 1), 1)
                              ])
                            ])
                          ]),
                          _createVNode("td", _hoisted_42, [
                            _createVNode("div", _hoisted_43, [
                              _createVNode("div", null, [
                                _createVNode("a", _hoisted_44, _toDisplayString(item.fullname.toUpperCase()), 1),
                                _createVNode("span", _hoisted_45, _toDisplayString(item.rusid), 1)
                              ])
                            ])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_46, [
                              _createVNode("div", null, [
                                _createVNode("a", _hoisted_47, _toDisplayString(item.prod), 1),
                                _createVNode("span", _hoisted_48, _toDisplayString(item.txndte), 1)
                              ])
                            ])
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", _hoisted_49, [
                              _createVNode("div", null, [
                                _createVNode("span", _hoisted_50, [
                                  _hoisted_51,
                                  _createVNode("a", _hoisted_52, _toDisplayString(item.complvl), 1)
                                ]),
                                _createVNode("span", _hoisted_53, [
                                  _hoisted_54,
                                  _createVNode("a", _hoisted_55, _toDisplayString(_ctx.numberWithCommas(item.compv)), 1)
                                ])
                              ])
                            ])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_56, [
            _createVNode("div", _hoisted_57, [
              _hoisted_58,
              _createVNode("div", _hoisted_59, [
                _createVNode("div", _hoisted_60, [
                  _createVNode("table", _hoisted_61, [
                    _hoisted_62,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list2, (item, index) => {
                        return (_openBlock(), _createBlock("tr", { key: index }, [
                          _createVNode("td", null, "         " + _toDisplayString(item.complvl), 1),
                          _createVNode("td", null, _toDisplayString(_ctx.numberWithCommas(item.total)), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createVNode(_component_pagination, {
        pagination: _ctx.pagination,
        callback: _ctx.reorderhistory,
        options: _ctx.paginationOptions
      }, null, 8, ["pagination", "callback", "options"])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}